export { BotDetailsModal } from '@app/components/Modals/BotDetailsModal/BotDetailsModal.main';
